import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { GetFavoriteMarketsFilterOptionsResponse } from './types';

/**
 * - 즐겨찾는 마켓 상품 리스트의 필터 옵션 (카테고리 + 정렬)
 */
export const getFavoriteMarketsFilterOptions = async () => {
  return defaultHttpClient
    .request<GetFavoriteMarketsFilterOptionsResponse>({
      method: 'GET',
      url: '/api/v2/favorite-markets/filter-options/',
    })
    .then(result => result.data);
};
